<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" rx="2" fill="#479ADF"/>
    <g clip-path="url(#clip0)">
      <path d="M8.80414 11.4727L8.62034 14.0579C8.88331 14.0579 8.9972 13.9449 9.13377 13.8093L10.3666 12.631L12.9213 14.5018C13.3898 14.763 13.7199 14.6255 13.8463 14.0708L15.5231 6.21342L15.5236 6.21296C15.6722 5.52037 15.2731 5.24953 14.8166 5.41944L4.96016 9.19305C4.28747 9.45416 4.29766 9.82916 4.84581 9.99907L7.36571 10.7829L13.219 7.12037C13.4944 6.93796 13.7449 7.03888 13.5389 7.22129L8.80414 11.4727Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect x="4.44434" y="4.44446" width="11.1111" height="11.1111" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'ShareTM'
}
</script>
